<template>
  <!--  VISTA LISTAR-->
  <template v-if="view === 'listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
      :hidden-default-button="isSubcomponent"
      :custom-create-actions="[listSecretariaEjecutora, listBeneficiarios, listContratos, listRubros, listFuenteConcreta,listTipoCAP,listFuenteMacro, listMacroEjecutor, () => {selectedFuenteMacro = undefined; selectedMacroEjecutor = undefined}]"
      @updateValues="setupUpdateValues">
      <button v-if="isSubcomponent" @click="$emit('updateValues', { 'view': 'listar' });"
        class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="inline-block w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
        </svg>
        <span class="ml-3">Volver</span>
      </button>
      <component :is="childHeaderComponent" :mainListCollectionData="mainListCollectionData" :auth-token="authToken"
        :table-columns="tableColumns" :queries="queries"></component>
    </HeaderComponent>

    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
      @updateValues="setupUpdateValues"></FilterRefactComponent>

    <TableComponent :entity="entity" :auth-token="authToken" :selected-data="selectedPasivoExigible" :table-columns="tableColumns"
      :collection-data="collectionData" :list-api="listApi" :custom-create-actions="[listTipoCAP]"
      :custom-update-selected-data="customUpdateSelectedData" :collection-tipo-cap="collectionTipoCAP"
      :custom-update-actions="[listSecretariaEjecutora, listBeneficiarios, listContratos, listRubros,listFuenteConcreta,listTipoCAP,listFuenteMacro,listMacroEjecutor, () => {selectedFuenteMacro = undefined; selectedMacroEjecutor = undefined}]"
      :custom-update-collection-data="customUpdateCollectionData" @updateValues="setupUpdateValues">
      <template v-slot="{ data }">
          <component :is="childTableComponent" :data="data" :view="view"
            :selected-data="selectedPasivoExigible"
            :load-data="loadDataPasivoExigible"
            :custom-update-collection-data="customUpdateCollectionData"
            :collection-tipo-cap="collectionTipoCAP" :custom-create-actions="[listTipoCAP]" 
            :custom-update-selected-data="customUpdateSelectedData"
            @data="(newData) => updateValues({ data: newData }, this)" @updateValues="setupUpdateValues">
          </component>
      </template>
    </TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
      :optionalParams="isSubcomponent ? queries : { ...queries, where: globalWhere }" @updateValues="setupUpdateValues">
    </PaginateRefactComponent>
  </template>

  <template v-else-if="view === 'cargar_caps'">
     <h1 style="font-weight: 700; font-size: 1.25rem; line-height: 1.75rem; margin-bottom: 1rem;">{{ tituloCargueCaps }}</h1>
      <component :is="handleChildComponentChange"  :data="data" :view="view" 
        :entity=" { gender: 'm', value: 'CAP' }" 
        :selected-data="selectedPasivoExigible" :auth-token="authToken" 
        :collection-tipo-cap="collectionTipoCAP"
        :load-data="loadDataPasivoExigible"
        :custom-create-actions="[listTipoCAP]"
        @customSaveData="(newCustomSaveData) => updateValues({ customSaveData: newCustomSaveData }, this)"
        :custom-update-collection-data="customUpdateCollectionData"
         @updateValues="setupUpdateValues"  
       >
    </component>
  </template>

  <template v-else-if="view === 'ver_caps'">
         <h1 style="font-weight: 700; font-size: 1.25rem; line-height: 1.75rem; margin-bottom: 1rem;">{{ tituloVisualizacionCaps }}</h1>
        <component :is="verCAPSComponent"  :data="data" :view="view" 
          :entity=" { gender: 'm', value: 'CAP' }" 
          :selected-data="selectedPasivoExigible" :auth-token="authToken" 
          :load-data="loadDataPasivoExigible"
          :collection-data-soportes = "collectionDataSoportes"
          :custom-create-actions="[listTipoCAP]"
          @customSaveData="(newCustomSaveData) => updateValues({ customSaveData: newCustomSaveData }, this)"
          :custom-update-collection-data="customUpdateCollectionData"
          @updateValues="setupUpdateValues"  
          @updateDataCap="updateDataCap2"
        >
    </component>
  </template>

  <template v-else-if="view === 'cargar_soportes_caps'">
         <h1 style="font-weight: 700; font-size: 1.25rem; line-height: 1.75rem; margin-bottom: 1rem;">{{ tituloSoportesCaps }}</h1>
        <component :is="cargueSoportesCAPSComponent"  :data="data" :view="view"
          :entity=" { gender: 'm', value: 'Soporte CAP' }" 
          :selected-data="selectedPasivoExigible" :auth-token="authToken" 
          :load-data="loadDataPasivoExigible"
          :dataCap = "dataCap"
          :custom-create-actions="[listTipoCAP]"
          @customSaveData="(newCustomSaveData) => updateValues({ customSaveData: newCustomSaveData }, this)"
          :custom-update-collection-data="customUpdateCollectionData"
          @updateValues="setupUpdateValues"  
        >
    </component>
  </template>

  <template v-else-if="view === 'editar_cap'">
    <h1 style="font-weight: 700; font-size: 1.25rem; line-height: 1.75rem; margin-bottom: 1rem;">{{ tituloEdicionCaps }}</h1>
    <component :is="edicionCAPSComponent"  :data="data" :view="view"
        :entity=" { gender: 'm', value: 'CAP' }" 
        :selected-data="selectedPasivoExigible" :auth-token="authToken" 
        :load-data="loadDataPasivoExigible"
        :dataCap = "dataCap"
        :custom-create-actions="[listTipoCAP]"
        @customSaveData="(newCustomSaveData) => updateValues({ customSaveData: newCustomSaveData }, this)"
        :custom-update-collection-data="customUpdateCollectionData"
        @updateValues="setupUpdateValues"  
        @updateDataCap="updateDataCap2"
      >
    </component>
  </template>

  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else-if="!isSubcomponent">                                                                                                                                              
    <CreateUpdateComponent :auth-token="authToken" :view="view" :entity="entity"
      @updateValues="setupUpdateValues" :list-api="listApi" :selected-data="selectedPasivoExigible" :load-data="loadDataPasivoExigible">
      <component :is="childFormComponent" :view="view" :paginate="paginate" :selected-data="selectedPasivoExigible"
        :load-data="loadDataPasivoExigible" :entity="entity" :list-api="listApi" :queries="queries"
        :collection-secretaria-ejecutora="collectionSecretariaEjecutora" :collection-beneficiarios="collectionBeneficiarios"
        :collection-contratos="collectionContratos" :custom-update-load-data="customUpdateLoadData"
        :auth-token="authToken" :collection-rubros="collectionRubros" :collection-fuente-concreta="collectionFuenteConcreta" :collection-macro-ejecutor = "collectionMacroEjecutor"
        :collection-fuente-macro="collectionFuenteMacro" :selectedFuenteMacro="selectedFuenteMacro" :selectedMacroEjecutor="selectedMacroEjecutor "
        @updateFuenteMacro="(newFuenteMacro) => {selectedFuenteMacro = newFuenteMacro; listFuenteConcreta()}"
        @updateMacroEjecutor="(newMacroEjecutor) => {selectedMacroEjecutor = newMacroEjecutor; listSecretariaEjecutora()}"
        :custom-update-value-data="customUpdateValueData" @updateValues="setupUpdateValues"
        @customSaveData="(newCustomSaveData) => updateValues({ customSaveData: newCustomSaveData }, this)"
        ></component>
    </CreateUpdateComponent> 
  </template>
</template>

<script>
import { reactive, ref } from "vue";
import { useAuth } from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import PasivoExigibleCrearActualizarComponent from "@/components/reservas/components/PasivoExigibleCrearActualizarComponent";
import { listCollectionData, updateValues, useLayoutMain } from "@/layouts/main";
import { copiaProfunda, separateNumberByComma } from "@/common/constants";
import PasivoExigibleChildTableComponent from "@/components/reservas/components/PasivoExigibleChildTableComponent";
import ProvisionesChildHeaderComponent from "@/components/reservas/components/ProvisionesChildHeaderComponent";
import CAPComponent from "@/components/reservas/components/CAPComponent.vue";
import VisualizacionCAPComponent from "./components/VisualizacionCAPComponent.vue";
import CargueSoportesCAPComponent from "./components/CargueSoportesCAPComponent.vue";
import EdicionCAPComponent from "./components/EdicionCAPComponent.vue";
// import mime from "mime";

export default {
  name: "GestionarReservas",
  props: ['customTitle', 'isSubcomponent', 'globalWhere'],
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    PasivoExigibleChildTableComponent,
    PasivoExigibleCrearActualizarComponent,
    CAPComponent,
    VisualizacionCAPComponent,
    EdicionCAPComponent,
    CargueSoportesCAPComponent,
    ProvisionesChildHeaderComponent
  },
  data: function () {
    return {
      dateRangePicker: undefined,
      Object: Object,
      tituloCargueCaps: 'Procesos CAPS',
      tituloVisualizacionCaps: 'Visualización CAPS',
      tituloEdicionCaps: 'Editar Información CAP',
      tituloSoportesCaps: 'Cargue Soportes CAPS',
      tituloSoportesAsociadosCaps: 'Visualización Soportes CAPS',
      title: this.customTitle ? this.customTitle : 'Pasivos Exigibles',
      entity: { gender: 'm', value: 'pasivo exigible' },
      childFormComponent: 'pasivoExigibleCrearActualizarComponent',
      childTableComponent: 'pasivoExigibleChildTableComponent',
      childHeaderComponent: 'provisionesChildHeaderComponent',
      handleChildComponentChange: 'CAPComponent',
      verCAPSComponent: 'VisualizacionCAPComponent',
      cargueSoportesCAPSComponent: 'CargueSoportesCAPComponent',
      edicionCAPSComponent: 'EdicionCAPComponent',
      updateValues,

      tableColumns: {
        'rp': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'RP'
        },
        'fecha': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Fecha'
        },
        'rubro.rubro': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Rubro Presupuestal'
        },
        'rubro.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre Rubro Presupuestal'
        },
        'fuenteConcreta.macroFuente.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Fuente Macro'
        },
        'fuenteConcreta.codigo': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Código Fuente'
        },
        'fuenteConcreta.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre Fuente'
        },
        'contrato.codigo': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Número del contrato'
        },
        'beneficiario.nit': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'NIT'
        },
        'beneficiario.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Beneficiario'
        },
        'contrato.concepto': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Objeto Contrato'
        },
        'contrato.valor': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Valor Contrato'
        },
        'valor': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Valor Pasivo Exigible'
        },
        'valor_actual': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Saldo Vigente'
        },
        'secretariaEjecutora.macroEjecutor.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Macro Ejecutor'
        },
        'secretariaEjecutora.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Ordenador del Gasto'
        },
        'identificador_informe': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Vigencia del Informe del Pasivo'
        },
        'estado': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      },
    };
  },
  async setup(props) {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const collectionBeneficiarios = ref([])
    const collectionContratos = ref([]);
    const collectionRubros = ref([]);
    const collectionFuenteConcreta = ref([]);
    const collectionSecretariaEjecutora = ref([]);
    const collectionTipoCAP = ref([]);
    const collectionFuenteMacro = ref([]);
    const collectionMacroEjecutor = ref([]);
    const selectedFuenteMacro = ref('')
    const selectedMacroEjecutor = ref('')
    const customSaveData = ref([]);
    const authToken = ref(authStored.authToken);
    let dataCap = ref('')
    /** Variable reactiva que contiene los valores devueltos por la consulta del API LIST. */
    const selectedPasivoExigible = ref({
      id: '',
      rp: '',
      fecha: '',
      id_rubro: '',
      id_codigo_fuente: '',
      id_contrato: '',
      id_beneficiario: '',
      valor: '',
      valor_actual: '',
      id_secretaria_ejecutora: '',
      fuenteConcreta: '',
      secretariaEjecutora: '',
      identificador_informe: '',
      estado: '',
      caps:'',
    });
    /** Variable reactiva que contiene los datos personalizados de la colección de pasivos exigibles a cargar. */
    const loadDataPasivoExigible = ref({
      rp: '',
      fecha: '',
      id_rubro: '',
      id_codigo_fuente: '',
      id_contrato: '',
      id_beneficiario: '',
      valor: '',
      valor_actual: '',
      id_secretaria_ejecutora: '',
      fuenteConcreta: '',
      secretariaEjecutora: '',
      identificador_informe: '',

    });
    /** Variable que contiene los endpoints de la API. */
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_PASIVOEXIGIBLE_CREATE,
      list: process.env.VUE_APP_NEST_PASIVOEXIGIBLE_FINDALL,
      update: process.env.VUE_APP_NEST_PASIVOEXIGIBLE_UPDATE,
      updateState: process.env.VUE_APP_NEST_PASIVOEXIGIBLE_UPDATESTATE
    });
    /**
     * Función que actualiza el valor de un campo personalizado de la colección de provisiones.
     *
     * @function
     * @param {string} key - Clave del campo personalizado a actualizar.
     * @param {any} value - Nuevo valor del campo personalizado.
     * @returns {any} Nuevo valor del campo personalizado actualizado.
     */
    const customUpdateValueData = (key, value) => {
      const listFieldNumeric = ['rp', 'id_macro_fuente','id_codigo_fuente', 'id_contrato','valor'];
      if (key === 'rp') {
      return value !== '' ? parseFloat(value.replace(/,/g, '')) : value;
      }
      if (listFieldNumeric.includes(key)) {
      return value !== '' ? value.replace(/,/g, '') : value;
      }
      if (key === 'fecha') return value !== '' ? value.split('T')[0] : value;
      console.log('valorrrr', value);
      return value;
    };
    /**
     * Actualiza los datos seleccionados con nuevos valores
     *
     * @function
     * @param {Object} selectedCollectionData - Objeto con los nuevos datos seleccionados
     * @returns {void}
     */
    const customUpdateSelectedData = (selectedCollectionData) => {
      const updatedSelectedData = {};
      for (const key of Object.keys(selectedPasivoExigible.value)) {
        updatedSelectedData[key] = customUpdateValueData(key, selectedCollectionData[key]);
      }
      selectedPasivoExigible.value = updatedSelectedData;
    }
    /**
     * Actualiza los datos de carga con nuevos valores
     *
     * @function
     * @returns {void}
     */
    const customUpdateLoadData = () => {
      for (const key in loadDataPasivoExigible.value) {
        let value = loadDataPasivoExigible.value[key];
        value = customUpdateValueData(key, value);
      }
    };
    /**
     * Actualiza los datos de la colección con nuevos valores
     *
     * @function
     * @returns {Object[]} Una copia profunda de la colección con los nuevos valores
     */
    const customUpdateCollectionData = () => {
      const copyCollectionData = copiaProfunda(collectionData.value);
      for (const copyData of copyCollectionData) {
        copyData['fecha'] = copyData['fecha'].split('T')[0];
        for (const key of ['valor_actual', 'valor']) {
          copyData[key] = separateNumberByComma(copyData[key]);
        }
        if (copyData['contrato'] && copyData['contrato']['valor']) {
          copyData['contrato']['valor'] = separateNumberByComma(copyData['contrato']['valor']);
        }
      }
      return copyCollectionData;
    };

    const listRubros = async () => await listCollectionData(
      process.env.VUE_APP_NEST_RUBRO_FINDALL, 
      { 'collectionRubros': collectionRubros }, 
      authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);

    const listFuenteConcreta = async () => await listCollectionData(
      process.env.VUE_APP_NEST_FUENTECONCRETA_FINDALL, 
      { 'collectionFuenteConcreta': collectionFuenteConcreta }, 
      authToken.value, undefined, undefined, undefined, undefined, undefined, selectedFuenteMacro.value ? 'id_fuente_macro = ' + selectedFuenteMacro.value : undefined, false);

    const listContratos = async () => await listCollectionData(
      process.env.VUE_APP_NEST_CONTRATO_FINDALL, 
      { 'collectionContratos': collectionContratos }, 
      authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);

    const listBeneficiarios = async () => await listCollectionData(
      process.env.VUE_APP_NEST_BENEFICIARIO_FINDALL, 
      { 'collectionBeneficiarios': collectionBeneficiarios }, 
      authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);

    const listSecretariaEjecutora = async () => await listCollectionData(
      process.env.VUE_APP_NEST_SECRETARIAEJECUTORA_FINDALL, 
      { 'collectionSecretariaEjecutora': collectionSecretariaEjecutora }, 
      authToken.value, undefined, undefined, undefined, undefined, undefined, selectedMacroEjecutor.value ? 'id_macro_ejecutor = ' + selectedMacroEjecutor.value : undefined, false);

      const listTipoCAP = async () => await listCollectionData(
      process.env.VUE_APP_NEST_TIPO_CAP_FINDALL, 
      { 'collectionTipoCAP': collectionTipoCAP }, 
      authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);

      const listFuenteMacro = async () => await listCollectionData(
        process.env.VUE_APP_NEST_FUENTEMACRO_FINDALL, 
        {'collectionFuenteMacro': collectionFuenteMacro}, 
        authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);

      const listMacroEjecutor = async () => await listCollectionData(
        process.env.VUE_APP_NEST_MACROEJECUTOR_FINDALL, 
        {'collectionMacroEjecutor': collectionMacroEjecutor}, 
        authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
      // await listMacroEjecutor();

    const updateDataCap2  = (cap) => {
      dataCap.value = cap.id
    }
      
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      mainListCollectionData
    } = await useLayoutMain(view, collectionData, authToken, selectedPasivoExigible, loadDataPasivoExigible, listApi, props.isSubcomponent ? { where: props.globalWhere } : undefined);
    return {
      view,
      collectionData,
      authToken,
      selectedPasivoExigible,
      loadDataPasivoExigible,
      listApi,
      paginate,
      queries,
      collectionBeneficiarios,
      collectionContratos,
      collectionRubros,
      collectionFuenteConcreta,
      collectionSecretariaEjecutora,
      collectionTipoCAP,
      collectionFuenteMacro,
      collectionMacroEjecutor,
      selectedFuenteMacro,
      selectedMacroEjecutor,
      setupUpdateValues,
      cleanLoadSelectedData,
      listSecretariaEjecutora,
      listTipoCAP,
      listBeneficiarios,
      listContratos,
      listRubros,
      listFuenteConcreta,
      listFuenteMacro,
      listMacroEjecutor,
      customUpdateSelectedData,
      customUpdateCollectionData,
      customUpdateLoadData,
      customUpdateValueData,
      // descargarDocumentoSoporte,
      mainListCollectionData,
      customSaveData,
      dataCap,
      updateDataCap2

    };
  },
};
</script>